import React, { useContext, useEffect, useRef, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { actualitiesLink, adminActualityEditLink, adminActualityLink } from '../../constants/endspoints'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deleteArticle, fetchArticles, updateArticleStatus } from '../../api/article';
import IsEmpty from '../../components/IsEmpty';
import { format } from 'date-fns';
import Modal from 'react-responsive-modal';
import { toast } from 'react-toastify';
import ResponsivePaginationComponent from 'react-responsive-pagination';
import { Overlay, Tooltip } from 'react-bootstrap';
import { AppContexte } from '../../contexts/context';

const ActualitiesList = () => {


    const { decodedToken } = useContext(AppContexte)


    const queryClient = useQueryClient();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedActuality, setSelectedActuality] = useState();
    const [copied, setCopied] = useState(false);
    const target = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);


    // **1. Fetch All actualities**
    const[title, setTitle] = useState('')
    const { data: actualitiesData, status } = useQuery({
        queryKey: ["actualities", {page: currentPage, title: title}],
        queryFn: () => fetchArticles({title: title, 'order[id]':"desc", page: currentPage}),
        retry: 1,
        refetchOnReconnect: true,
    });


    // Mutation pour gérer la suppression
    const toastDel = useRef(null);
    const deleteMutation = useMutation({
        mutationFn: deleteArticle,
        onMutate: ()=>{
            toastDel.current = toast.loading("Suppression en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: () => {
            toast.dismiss(toastDel.current)
                toastDel.current = toast.success("Actualité supprimée avec succès", {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            queryClient.invalidateQueries({ queryKey: ["actualities"] });
            setIsModalOpen(false);
        },
        onError: (err) => {
            toast.dismiss(toastDel.current)
                toastDel.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
            console.log("Erreur lors de la suppression :", err);
        },
    });


    // Confirmer la suppression
    const handleConfirmDelete = (actualityId) => {
        deleteMutation.mutate(actualityId);
    };




    // Mutation pour gérer le status
    const toastStatus = useRef(null);
    const statusMutation = useMutation({
        mutationFn: (article) => updateArticleStatus(article.articleId, article.status),
        onMutate: (e)=>{
            toastStatus.current = toast.loading(`${e?.status === true? "Activation":"Désactivation"} en cours...`, { 
                position: 'top-right',
            });
        },
        onSuccess: (res) => {
            toast.dismiss(toastStatus.current);
            toastStatus.current = toast.success(`${res?.data?.status === true ? "Activé": "Desactivé"} avec succès`, {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            queryClient.invalidateQueries({ queryKey: ["actualities"] });
            toastStatus.current = null;
        },
        onError: (err) => {
            toast.dismiss(toastStatus.current);
            toastStatus.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
            toastStatus.current = null;
        },
    });

    const toggleStatus = (articleId, status) => {
        statusMutation.mutate({articleId:articleId, status:status})
    }





    // Copy link to clipboard
    const handleCopy = (id) => {
        navigator.clipboard.writeText(window.location.origin + actualitiesLink + '/' + id).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        });
        target.current = document.querySelector(`#copy-${id}`);
    };


    // 5. Pagination setup
    const itemsPerPage = 8;
    const totalPages = Math.ceil((actualitiesData?.data?.totalItems || 0) / itemsPerPage);
    const [actualities, setActualities] = useState();

    useEffect(() => {
        setActualities(actualitiesData?.data?.member);
    }, [actualitiesData]);


    function handlePageChange(page) {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'instant' });
    }


    return (
        <div>
            <h1 className='fs-3 fw-bold mb-3'> <NavLink className={'fs-3 fw-bold text-white'} to={adminActualityLink}>Actualités</NavLink> / Liste</h1>

            <div className='bg-black rounded-3 p-2 shadow'>
                <h2 className='fs-5 fw-bold mb-2'>Liste des actualités</h2>

                <div className='d-flex justify-content-between align-items-center'>
                    <NavLink to={adminActualityLink} className='d-flex align-items-center px-2 py-1 bgcolor-primary rounded-3'>
                        <i className="fa-light fa-square-plus me-2 text-white"></i>
                        <span className=' fs-9s text-white'>Ajouter une actualité</span>
                    </NavLink>
                    <div className='d-flex align-items-center'>
                        <div className='px-2 border border-1 d-flex align-items-center'>
                            <i className=' fa fa-search'></i>
                            <input 
                                type='search' 
                                placeholder='Rechercher un titre' 
                                value={title}
                                onChange={(e) =>{setTitle(e.target.value); setCurrentPage(1)}}
                                className='form-control shadow-none bg-black border-0 fs-9s text-white py-1'
                            />
                        </div>
                    </div>
                </div>

                {/* Liste */}
                <div className='mt-3 table-responsive'>
                    <table className='table table-dark table-striped table-hover fs-9s align-middle'>
                        <thead>
                            <tr>
                                <th className='fs-9s'>#</th>
                                <th className='fs-9s'>Titre</th>
                                <th className='fs-9s'>Catégorie</th>
                                <th className='fs-9s'>Date</th>
                                <th className='fs-9s'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            status === "pending"?
                            [1,2,3,4,5,6,7,8].map((item, index) => (
                                <tr key={index}>
                                    <td className='fs-9s placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                    <td className='fs-9s placeholder-wave'><i className='placeholder col-12 bgcolor-primary'></i></td>
                                </tr>
                            ))
                            :status === "error"?
                            <tr>
                                <td  colspan="5" className='w-100'>
                                    <IsEmpty icon={"fa-light fa-exclamation-circle"} message={"Une erreur c'est produite"} />
                                </td>
                            </tr>
                            :
                            actualities?.length <= 0 ?
                                <tr>
                                    <td  colspan="5" className='w-100'>
                                        <IsEmpty icon={"fa-light fa-newspaper"} message={"Aucune actualité enregistrée"} />
                                    </td>
                                </tr>
                            :actualities?.map((actuality, index) =>  {
                                return (
                                    <tr key={index}>
                                        <td className='fs-9s fw-bold'>{((currentPage - 1) * itemsPerPage) + index + 1}</td>
                                        <td className=''><span className='text-truncate-1 fs-9s'>{actuality.title}</span></td>
                                        <td className='fs-9s'>{actuality?.Category?.name}</td>
                                        <td className='fs-9s text-nowrap'>{format(new Date(actuality.createdAt), "dd MMM yyyy")}</td>
                                        <td className='fs-9s'>
                                            <div className=' d-flex flex-nowrap align-items-center'>
                                                <NavLink to={`${actualitiesLink}/${actuality.id}`} target="_blank" title='Voir' className='fa-light fa-eye fs-9s text-success me-2'></NavLink>
                                                <NavLink to={`${adminActualityEditLink}/${actuality.id}`} target="_blank" title='Modifier' className='fa-light fa-edit fs-9s text-info me-2'></NavLink>
                                                <i onClick={()=>{setSelectedActuality(actuality); setIsModalOpen(true)}} role='button' title='Supprimer' className='fa-light fa-trash fs-9s text-danger'></i>
                                                {actuality?.status === true && <i className="fa-light fa-copy ms-2 color-primary" id={`copy-${actuality?.id}`} onClick={()=>handleCopy(actuality.id)} role='button' title='copier'></i>}
                                                {
                                                    decodedToken?.roles[0] === "ROLE_ADMIN" &&
                                                    <div className=' d-flex flex-nowrap align-items-center ms-2'>
                                                        <div className="form-check form-switch py-0 m-0 h-auto" title='Bloquer/Debloquer'>
                                                            <input className="form-check-input rounded-pill shadow-none" type="checkbox" role="switch" onChange={()=>toggleStatus(actuality?.id, !actuality?.status)} checked={actuality.status} disabled={statusMutation.isPending}  />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                    <Overlay target={target.current} show={copied} placement="top">
                        {(props) => (
                        <Tooltip id="overlay-example" className='program-tooltip' {...props}>
                            Copié
                        </Tooltip>
                        )}
                    </Overlay>
                </div>


                {/* Pagination */}
                <div className=' d-flex justify-content-end actualities'>
                    <ResponsivePaginationComponent
                    total={totalPages}
                    current={currentPage}
                    onPageChange={page => handlePageChange(page)}
                    />
                </div>
            </div>



            {/* Modal de confirmation */}
            <Modal open={isModalOpen} onClose={()=>deleteMutation.isPending?null:setIsModalOpen(false)} center focusTrapped={false}>
                <h2 className='fw-bold text-center fs-2 mb-1 text-danger'>Confirmer la suppression</h2>
                <p className='fs-9s mb-0 text-center'>Êtes-vous sûr de vouloir supprimer cette actualité ?</p>
                <h3 className='fw-bold text-center fs-4'>{selectedActuality?.title}</h3>
                <button className='border-0 rounded bg-danger text-white px-2 py-1 me-2 fs-9s' onClick={()=>handleConfirmDelete(selectedActuality?.id)} disabled={deleteMutation.isPending}>
                {deleteMutation.isPending ? "Suppression en cours..." : "Supprimer"}
                </button>
                <button className='border border-1 bordercolor-primary rounded bg-transparent text-black fs-9s px-2 py-1' disabled={deleteMutation.isPending} onClick={()=>setIsModalOpen(false)}>Annuler</button>
            </Modal>
        </div>
    )
}

export default ActualitiesList